module.exports = __webpack_public_path__ + "static/media/3783.d7923e82.jpg";